import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-bf-gold/30 border-t-bf-gold" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
};
